import CN from "@/common/language/CN.js";
import EN from "@/common/language/EN.js";
var languages = {
    CN: Object.assign(CN, {}),
    EN: Object.assign(EN, {}),
};
export default languages;
